import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class DRSFilter {
  scac:any = "";
  fromDate: NgbDate = null;
  toDate: NgbDate = null;
  drsStartDate: string = null;
  drsEndDate: string = null;
}
